{
  "OnavailablestateLabel": "Sullo Stato disponibile Oltre:",
  "OnbusystateLabel": "Sullo Stato Occupato Sopra:",
  "OnnaordndstateLabel": "Su N\/A o sullo stato DND Over:",
  "OnwrapupLabel": "Sullo Stato di Wrap-Up Over:",
  "OnavailablestateEnabledHiddenlabel": "L'impostazione Sopra stato disponibile è abilitata?",
  "OnbusystateEnabledHiddenlabel": "È abilitata la sovraimpostazione dello stato occupato?",
  "OnnaordndstateEnabledHiddenlabel": "L'impostazione On N\/A o DND State Over è abilitata?",
  "OnwrapupEnabledHiddenlabel": "L'impostazione On Wrap-Up State Over è abilitata?",
  "OnavailablestatePlaceholder": "30s",
  "OnbusystatePlaceholder": "5m 0s",
  "OnnaordndstatePlaceholder": "3m 0s",
  "OnwrapupPlaceholder": "3m 0s",
  "ACDStateThresholds_SectionHeader": "Soglie di stato ACD",
  "ACDStateThresholds_SectionPara": "È possibile attivare gli allarmi quando gli agenti rimangono per troppo tempo in un determinato stato ACD. Scegliere gli stati ACD ",
  "NAME": "ACDStateThresholds"
}